export function transformLimitBackToOriginal(transformedLimits) {
  // If input is null or undefined, return an empty array
  if (!transformedLimits) {
    return [];
  }

  return transformedLimits.map((limit) => {
    // Create a copy to avoid modifying the original
    const originalLimit = { ...limit };

    // Convert back from the two separate fields to the original entity_type format
    if (originalLimit.entity_type === "reward" && originalLimit.limit_type) {
      if (originalLimit.limit_type === "COUNT") {
        originalLimit.entity_type = "reward_count";
      } else if (originalLimit.limit_type === "VALUE") {
        originalLimit.entity_type = "reward_value";
      }

      // Remove the limit_type property as it wasn't in the original format
      delete originalLimit.limit_type;
    }

    // Convert 'overall' back to 'product' in limit_level
    if (originalLimit.limit_level === "overall") {
      originalLimit.limit_level = "product";
    }

    return originalLimit;
  });
}

export function processRewardLimits(rewardLimits) {
  // Initialize the limits object with default values including isOpen properties
  const limitsObject = {
    user_level_isOpen: false,
    product_level_isOpen: false,
    user_level_limit: false,
    user_level_value: false,
    product_level_limit: false,
    product_level_value: false,
  };

  // Return default object if rewardLimits is not an array
  if (!Array.isArray(rewardLimits)) {
    return limitsObject;
  }

  // Process each limit in the array
  rewardLimits.forEach((limit) => {
    // First, handle the limit_level mapping (overall -> product)
    const limitLevel =
      limit.limit_level === "overall" ? "product" : limit.limit_level;

    // Construct the key based on limit_level and limit_type (COUNT or VALUE)
    const entityType = limit.limit_type === "COUNT" ? "limit" : "value";
    const key = `${limitLevel}_level_${entityType}`;

    // Set the corresponding flag to true
    limitsObject[key] = true;

    // Set the corresponding isOpen flag to true
    limitsObject[`${limitLevel}_level_isOpen`] = true;
  });

  return limitsObject;
}

export function getRewardLimitsFunction(reward) {
  return reward?.rewardLimits
    ?.map((item) => {
      // Remove empty keys from each object
      let cleanedItem = Object.keys(item)
        .filter((key) => item[key] !== "")
        .reduce((acc, key) => {
          acc[key] = item[key];
          return acc;
        }, {});

      // Transform entity_type into two separate keys
      if (cleanedItem.entity_type === "reward_count") {
        cleanedItem.entity_type = "reward";
        cleanedItem.limit_type = "COUNT";
      } else if (cleanedItem.entity_type === "reward_value") {
        cleanedItem.entity_type = "reward";
        cleanedItem.limit_type = "VALUE";
      }

      // Change "product" to "overall" in limit_level
      if (cleanedItem.limit_level === "product") {
        cleanedItem.limit_level = "overall";
      }

      // Check if all limit keys are empty
      const hasLimits = [
        "daily_limit",
        "weekly_limit",
        "monthly_limit",
        "yearly_limit",
        "overall_limit",
      ].some((limitKey) => cleanedItem[limitKey] !== undefined);

      // Only return the object if it has non-empty limits
      return hasLimits ? cleanedItem : null;
    })
    .filter((item) => item !== null)
    .filter((item) => {
      // Check conditions for user level
      if (item.limit_level === "user") {
        if (item?.limit_type === "COUNT") {
          return reward?.user_level_limit === true;
        }
        if (item?.limit_type === "VALUE") {
          return reward?.user_level_value === true;
        }
      }

      // Check conditions for overall level (formerly product)
      if (item.limit_level === "overall") {
        if (item?.limit_type === "COUNT") {
          return reward?.product_level_limit === true;
        }
        if (item?.limit_type === "VALUE") {
          return reward?.product_level_value === true;
        }
      }

      return false; // Filter out any items that don't match the conditions
    });
}
